import { DatatableCell, Skeleton } from '@monksflow/monks-ui';

import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

interface ToolsTableV2SkeletonRowProps {
  showType: boolean;
}

/**
 * Loading placeholder row for {@link ToolsTableV2}.
 *
 * Each placeholder mirrors the SHAPE of the cell it stands in for — the circular
 * tool badge, the name over its description, the rounded-full status pill — so
 * the skeleton reads as a table rather than a block of grey bars.
 */
export function ToolsTableV2SkeletonRow({ showType }: ToolsTableV2SkeletonRowProps) {
  return (
    <TableSkeletonRow testId="tools-table-skeleton-row">
      <DatatableCell>
        <div className="flex items-center gap-xs">
          <Skeleton data-testid="skeleton-loader" className="size-8 rounded-full" />
          <div className="flex flex-col gap-3xs">
            <Skeleton data-testid="skeleton-loader" className="h-4 w-40" />
            <Skeleton data-testid="skeleton-loader" className="h-3 w-64" />
          </div>
        </div>
      </DatatableCell>

      <DatatableCell>
        <Skeleton data-testid="skeleton-loader" className="h-5 w-28 rounded-full" />
      </DatatableCell>

      {showType && (
        <DatatableCell>
          <Skeleton data-testid="skeleton-loader" className="h-4 w-16" />
        </DatatableCell>
      )}

      <DatatableCell>
        <Skeleton data-testid="skeleton-loader" className="h-5 w-32 rounded-full" />
      </DatatableCell>

      <TableSkeletonActionsCell />
    </TableSkeletonRow>
  );
}
